import { DataBean } from "../DataBean";

export class QualityInspectionOperation extends DataBean {

  public async getQualityInspectionOperationCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getQualityInspectionOperationCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getQualityInspectionOperationRender( page: number, rows: number, properties: any, fromDate: any, uptoDate: any ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.Report_getQualityInspectionOperationRender_Number_Number_java.util.Map_java.util.Date_java.util.Date",
      [page, rows, properties, fromDate, uptoDate]
    );
  }

  public async deleteQualityInspectionOperation(idqualityinspectionoperation: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteQualityInspectionOperation_Number", [idqualityinspectionoperation]);
  }

  public async updateQualityInspectionOperation(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.QualityInspectionOperation_updateQualityInspectionOperation_com.orange.finance.processcontract.bean.QualityInspectionOperation",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.QualityInspectionOperation",
        },
      ]
    );
  }
}
